import firebase, { database } from "../firebase";
import * as constants from "../Constatnts";
import axios from "axios";


export function generateEInvoice(sale) {
  return async (dispatch, getState) => {
    // console.log("sale", JSON.stringify(sale));
    try {
      const token = getState().user.uat;
      const res = await axios.post(
        constants.API_URL + "/einvoice",
        {sale:sale},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("generateEInvoice", JSON.stringify(res.data));
      if (res.data.success) {
        return {
          success: true,
          message: "",
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          message: res.data.message,
          data: null,
        };
      }
    } catch (err) {
      console.log("generateEInvoice", JSON.stringify(err));
      return {
        success: false,
        message: "Error while processing data",
        data: null,
      };
    }
  };
}

export function getSalesHistory(
  from = 0,
  size = 25,
  updatedOn = null,
  storeId = null,
  fromDate = null,
  toDate = null,
  cashRegisterId = null,
  transactionTypeId = null,
  transactionNo = null,
  customerFirstName = null,
  customerEmailId = null,
  customerPhoneNo = null,
  searchParam = null
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/transaction/sales";
      let queryParams = [];

      const formatDateParam = (date) => {
        if (!date) return null;

        const d = new Date(date);

        if (isNaN(d.getTime())) return null;

        return d.toISOString().split("T")[0];
      };

      if (from !== undefined && from !== null) {
        queryParams.push("from=" + from);
      }

      if (size !== undefined && size !== null) {
        queryParams.push("size=" + size);
      }

      if (updatedOn) {
        const formattedDate = formatDateParam(updatedOn);

        if (formattedDate) {
          queryParams.push("updatedOn=" + formattedDate);
        }
      }

      // storeId handling (array or string)
      if (storeId) {
        if (Array.isArray(storeId)) {
          const validIds = storeId.filter(function(id) {
            return id !== null && id !== undefined && id !== "";
          });

          if (validIds.length > 0) {
            queryParams.push(
              "storeId=" + encodeURIComponent(validIds.join(","))
            );
          }
        } else if (typeof storeId === "string") {
          if (storeId.trim() !== "") {
            queryParams.push("storeId=" + encodeURIComponent(storeId.trim()));
          }
        }
      }

      if (fromDate) {
        const formattedDate = formatDateParam(fromDate);

        if (formattedDate) {
          queryParams.push("fromDate=" + formattedDate);
        }
      }

      if (toDate) {
        const formattedDate = formatDateParam(toDate);

        if (formattedDate) {
          queryParams.push("toDate=" + formattedDate);
        }
      }

      if (cashRegisterId) {
        queryParams.push(
          "cashRegisterId=" + encodeURIComponent(cashRegisterId)
        );
      }

      if (transactionTypeId) {
        queryParams.push(
          "transactionTypeId=" + encodeURIComponent(transactionTypeId)
        );
      }

      if (transactionNo) {
        queryParams.push("transactionNo=" + encodeURIComponent(transactionNo));
      }

      if (customerFirstName) {
        queryParams.push(
          "customerFirstName=" + encodeURIComponent(customerFirstName)
        );
      }

      if (customerEmailId) {
        queryParams.push(
          "customerEmailId=" + encodeURIComponent(customerEmailId)
        );
      }

      if (customerPhoneNo) {
        queryParams.push(
          "customerPhoneNo=" + encodeURIComponent(customerPhoneNo)
        );
      }

      if (searchParam) {
        queryParams.push("searchParam=" + encodeURIComponent(searchParam));
      }

      if (queryParams.length > 0) {
        apiUrl += "?" + queryParams.join("&");
      }

      const response = await axios.get(constants.API_URL + apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (err) {
      console.error("Error fetching sales history:", err);

      throw err;
    }
  };
}

export function addSales(sale, cashRegisterID, transactionTypeID) {
  return async (dispatch, getState) => {
    try {
      if (sale.Customer) {
        sale.Customer.Addresses = sale.Customer.Addresses || null;
      }

      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/transaction/sales",
        sale,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // let salesID = "";
      let saleResponse = null;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        // salesID = response.data.sale.key;
        saleResponse = response.data.sale;
      }
      return saleResponse;
      // return salesID;
    } catch (error) {
      console.error("addSales failed:", error);
      return null;
    }
  };
}

export function saveKOT(KOT) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(constants.API_URL + "/kot", KOT, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      let key = "";
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        key = response.data.data.key;
      }
      // console.log("saveKOT", key);
      return key;
    } catch (error) {
      console.error("saveKOT failed:", error);
      return "";
    }
  };
}

export function updateSalesStatus(key, status) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/transaction/sales/" + key + "/status",
        { TransactionStatus: status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let responseSuccess = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        responseSuccess = true;
      }
      return responseSuccess;
    } catch (error) {
      console.error("updateSalesStatus failed:", error);
      return false;
    }
  };
}

export function updateSales(sale, key, action) {
  return async (dispatch, getState) => {
    try {
      sale.BackEndUpdate = false;
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + "/transaction/sales/" + key,
        sale,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let responseSuccess = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        responseSuccess = true;
      }
      return responseSuccess;
    } catch (error) {
      console.error("updateSales failed:", error);
      return false;
    }
  };
}

export function cancelSales(cancellationReason, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/transaction/sales/" + key + "/cancel",
        { CancellationReason: cancellationReason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let responseSuccess = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        responseSuccess = true;
      }
      return responseSuccess;
    } catch (error) {
      console.error("cancelSales failed:", error);
      return false;
    }
  };
}

export function getKOTRunningNo(cashRegisterID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL + "/kotrunningno/" + cashRegisterID,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let runningNo = 0;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        runningNo = response.data.runningNo;
      }
      return runningNo;
    } catch (error) {
      console.error("getKOTRunningNo failed:", error);
      return 0;
    }
  };
}

export function getSaleDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL + "/transaction/sales/" + key,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let sale = null;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        sale = response.data.saleData;
      }
      return sale;
    } catch (error) {
      console.error("getSaleDetails failed:", error);
      return null;
    }
  };
}

export function generatePowerUserOTP(registrationID, storeID, userID) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      // Build payload
      let otp = {
      StoreID: storeID,
      UserID: userID,
    };
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/otp/poweruser/generate`,
        otp,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }

      return false;
    } catch (error) {
      console.error("Error generating power user otp:", error.response || error.message);
      throw error;
    }
  };
}

export function validatePowerUserOTP(registrationID, storeID, userID, OTP){
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      // Build payload
     let searchParameters = {
      RegistrationID: registrationID,
      StoreID: storeID,
      UserID: userID,
      OTP: OTP,
    };
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/otp/poweruser/validate`,
        searchParameters,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        if(response.data.status){
return true
        }
        
      }else{
        alert(response.data.message || "Invalid Otp")
         return false;
      }

      return false;
    } catch (error) {
      console.error("Error validating power user otp:", error.response || error.message);
      throw error;
    }
  };
}


export function generateOTP(
  registrationID,
  storeID,
  cashRegisterID,
  customerID,
  moduleID = ""
)  {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      // Build payload
    let otp = {
      storeid: storeID,
      moduleID: moduleID,
      cashregisterid: cashRegisterID,
      customerID: customerID,
    };
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/otp`,
        otp,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }

      return false;
    } catch (error) {
      console.error("Error generating  user otp:", error.response || error.message);
      throw error;
    }
  };
}


export function validateOTP(
  registrationID,
  storeID,
  cashRegisterID,
  customerID,
  OTP
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/otp?storeid=${storeID}&OTP=${OTP}&cashregisterid=${cashRegisterID}&customerid=${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let status=false;
      if(response.data.code=="0"){
            if(response.data.status){
              status=true
            }
      }
      
      return status;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getCashRegisterOpeningDetails(cashRegisterID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL +
          "/setup/stores/cashregisters/" +
          cashRegisterID +
          "/" +
          "Open" +
          "/closinglist",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let cashregisterClosingDetails = null;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        console.log(
          "cashregisterClosingDetails calle",
          response.data.cashRegisterClosingList
        );
        if (
          response.data.cashRegisterClosingList &&
          response.data.cashRegisterClosingList.length > 0
        ) {
          cashregisterClosingDetails = response.data.cashRegisterClosingList[0];
        }
      }
      return cashregisterClosingDetails;
    } catch (error) {
      return null;
    }
    // return database
    //   .collection("CashRegisterClosing")
    //   .where("CashRegisterID", "==", cashRegisterID)
    //   .where("Status", "==", "Open")
    //   .get()
    //   .then((querySnapshot) => {
    //     let obj;
    //     querySnapshot.forEach((doc) => {
    //       obj = { key: doc.id, ...doc.data() };
    //     });
    //     console.log("getCashRegisterOpeningDetails", obj);
    //     return obj;
    //   })
    //   .catch((error) => {
    //     return null;
    //     console.log(error);
    //   });
  };
}

export function getCashRegisterClosingDetails(key, storeID, cashregisterID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL +
          "/setup/stores/" +
          storeID +
          "/cashregisters/" +
          cashregisterID +
          "/" +
          key +
          "/closinglistbyid",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let cashregisterClosingDetails = null;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        cashregisterClosingDetails = response.data.data;
      }
      return cashregisterClosingDetails;
    } catch (error) {
      console.error("getCashRegisterClosingDetails failed:", error);
      return null;
    }
    // /setup/stores/:storeID/cashregisters/:cashregistersID?/:cashregisterclosingID/closinglistbyid
    // return database
    //   .collection("CashRegisterClosing")
    //   .doc(key)
    //   .get()
    //   .then((doc) => {
    //     if (doc.exists) {
    //       return doc.data();
    //     } else {
    //       console.log("No such Cash Register Closing record!");
    //     }
    //   });
  };
}

export function openCashRegister(cashRegisterClosing) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/setup/openingcashregister",
        cashRegisterClosing,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let cashregisterClosingDetails = null;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        cashregisterClosingDetails = response.data.data;
      }
      return cashregisterClosingDetails;
    } catch (error) {
      console.error("openCashRegister failed:", error);
      return null;
    }
    // cashRegisterClosing.ActionOn = firebase.firestore.FieldValue.serverTimestamp();
    // cashRegisterClosing.ActionBy = getState().user.user.Name;
    // cashRegisterClosing.ActionByUID = getState().user.user.UID;
    // cashRegisterClosing.ActionByEmailID = getState().user.user.EmailID;
    // cashRegisterClosing.Action = constants.AUDIT_TRAIL_NEW;
    // return database
    //   .collection("CashRegisterClosing")
    //   .add({
    //     ...cashRegisterClosing,
    //   })
    //   .then(function(docRef) {
    //     return { key: docRef.id, ...cashRegisterClosing };
    //   })
    //   .catch(function(error) {
    //     return null;
    //     console.error("Error saving sales : ", error);
    //   });
  };
}

export function closeCashRegister(
  key,
  cashRegisterID,
  storeID,
  cashRegisterClosing
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL +
          "/setup/stores/" +
          storeID +
          "/cashregisters/" +
          cashRegisterID +
          "/" +
          key +
          "/closinglist",
        cashRegisterClosing,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let responseSuccess = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        responseSuccess = true;
      }
      return responseSuccess;
    } catch (error) {
      console.error("updateSales failed:", error);
      return false;
    }
  };
  // return (dispatch, getState) => {
  //   cashRegisterClosing.ActionOn = firebase.firestore.FieldValue.serverTimestamp();
  //   cashRegisterClosing.ActionBy = getState().user.user.Name;
  //   cashRegisterClosing.ActionByUID = getState().user.user.UID;
  //   cashRegisterClosing.ActionByEmailID = getState().user.user.EmailID;
  //   cashRegisterClosing.Action = constants.AUDIT_TRAIL_EDIT;
  //   return database
  //     .collection("CashRegisterClosing")
  //     .doc(key)
  //     .update({
  //       ...cashRegisterClosing,
  //     });
  // };
}

// export function 848(key, cashRegisterClosing) {
//   return (dispatch, getState) => {
//     console.log("deleteCashRegister.cashRegisterClosing", cashRegisterClosing);
//     cashRegisterClosing.CashRegisterID =
//       cashRegisterClosing.CashRegisterID + "_delete";
//     cashRegisterClosing.StoreID = cashRegisterClosing.StoreID + "_delete";
//     cashRegisterClosing.RegistrationID =
//       cashRegisterClosing.RegistrationID + "_delete";
//     return database
//       .collection("CashRegisterClosing")
//       .doc(key)
//       .update({
//         ...cashRegisterClosing,
//       });
//   };
// }

// export function checkIfWalletDebitTransactionExists(
//   storeID,
//   transactionNo,
//   debitAmount
// ) {
//   return (dispatch, getState) => {
//     return database
//       .collection("WalletLedgers")
//       .where("StoreID", "==", storeID)
//       .where("TransactionNo", "==", transactionNo)
//       .where("DebitAmount", "==", debitAmount)
//       .limit(1)
//       .get()
//       .then((querySnapshot) => {
//         let exists = false;
//         querySnapshot.forEach((doc) => {
//           exists = true;
//         });
//         return exists;
//       })
//       .catch((error) => {
//         console.log(error);
//         return false;
//       });
//   };
// }

export function getPaymenDetailstForCashRegisterClosing(
  storeID,
  cashRegisterID,
  openingTime
) {
  return async (dispatch, getState) => {
    try {
      const formattedOpeningTime = new Date(openingTime).toISOString();
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL +
          "/setup/stores/" +
          storeID +
          "/cashregisters/" +
          cashRegisterID +
          "/paymentdetails?openingTime=" +
          formattedOpeningTime,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let paymentModeAmount = [];
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        paymentModeAmount = response.data.paymentModeAmount;
      }
      return paymentModeAmount;
    } catch (error) {
      console.error("getPaymenDetailstForCashRegisterClosing failed:", error);
      return [];
    }

    // return database
    //   .collection("Sales")
    //   .where("RegistrationID", "==", registrationID)
    //   .where("CashRegister.key", "==", cashRegisterID)
    //   .where("TransactionDate", "<=", new Date())
    //   .where("TransactionDate", ">=", openingTime)
    //   .get()
    //   .then((querySnapshot) => {
    //     let paymentModeAmount = [];
    //     let balanceAmount = 0;
    //     querySnapshot.forEach((doc) => {
    //       // console.log(doc.data())
    //       console.log(doc.data());
    //       if (!doc.data().hasOwnProperty("CancellationReason")) {
    //         if (doc.data().BalanceAmount) {
    //           balanceAmount =
    //             Number(balanceAmount) + Number(doc.data().BalanceAmount);
    //         }
    //         doc.data().Payments.map((payment) => {
    //           let index = -1;
    //           let amount = 0;
    //           if (payment.PaymentMode.toLowerCase() === "cash") {
    //             amount =
    //               Number(payment.Amount) - Number(doc.data().BillChangeDue);
    //           } else {
    //             amount = Number(payment.Amount);
    //           }
    //           for (var i = 0; i < paymentModeAmount.length; i++) {
    //             if (paymentModeAmount[i].PaymentMode === payment.PaymentMode) {
    //               index = i;
    //             }
    //           }
    //           if (index === -1) {
    //             paymentModeAmount.push({
    //               PaymentMode: payment.PaymentMode,
    //               Amount: amount,
    //             });
    //           } else {
    //             paymentModeAmount[index].Amount =
    //               Number(paymentModeAmount[index].Amount) + amount;
    //           }
    //         });
    //       }
    //     });
    //     // console.log('paymentModeAmount',paymentModeAmount)
    //     paymentModeAmount.push({
    //       PaymentMode: "Balance",
    //       Amount: balanceAmount,
    //     });
    //     return paymentModeAmount;
    //   })
    //   .catch((error) => {
    //     console.log("Error getting invoice list: ", error);
    //   });
  };
}

export function getCashRegisterClosingList(storeID, cashRegisterID, status) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL +
          "/setup/stores/" +
          storeID +
          "/cashregisters/" +
          status +
          "/closinglist",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let cashRegisterClosingList = [];
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        cashRegisterClosingList = response.data.cashRegisterClosingList;
      }
      return cashRegisterClosingList;
    } catch (error) {
      console.error("getPaymenDetailstForCashRegisterClosing failed:", error);
      return [];
    }
    // let cashRegisterClosingRef = database.collection("CashRegisterClosing");
    // let query = cashRegisterClosingRef
    //   .where("StoreID", "==", storeID)
    //   .where("Status", "==", status);
    // if (cashRegisterID.trim() !== "") {
    //   query = query.where("CashRegisterID", "==", cashRegisterID);
    // }
    // return query
    //   .get()
    //   .then((querySnapshot) => {
    //     let list = [];
    //     querySnapshot.forEach((doc) => {
    //       list.push({ key: doc.id, ...doc.data() });
    //     });
    //     // console.log('')
    //     return list;
    //   })
    //   .catch((error) => {
    //     return null;
    //     console.log(error);
    //   });
  };
}

export function getCustomerOutstanding(customerID) {
  return async (dispatch, getState) => {
    let searchParameters = {
      _source: [
        "ChildTransactionNo",
        "IsConvert",
        "ReceivedPaymentTransactions",
        "ReceiveAmount",
        "BalanceAmount",
        "TransactionNo",
        "TransactionType",
        "TransactionDate",
        "BillAmount",
      ],
      from: 0,
      size: 10000,
      track_total_hits: true,
      query: {
        bool: {
          must: [
            {
              term: {
                "Customer.key.keyword": customerID,
              },
            },
            {
              term: {
                "TransactionType.SalesImpactChecked": true,
              },
            },
            {
              match: {
                "Store.key": getState().user.store.key,
              },
            },
          ],
          must_not: [
            {
              exists: {
                field: "CancellationReason",
              },
            },
            {
              match: { BalanceAmount: 0 },
            },
          ],
        },
      },
      sort: [
        {
          TransactionDate: {
            order: "desc",
          },
        },
      ],
    };
    const token = getState().user.uat;
    let result = await axios
      .post(
        constants.API_URL + "/transaction/getsales",
        {
          text: searchParameters,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});

    const sales = [];
    // console.log("getCustomerOutstanding", result);
    let sanitizedMessage = result.text;
    sanitizedMessage.hits.hits.map((data, index) => {
      if (
        data._source.hasOwnProperty("ChildTransactionNo") &&
        data._source.ChildTransactionNo.trim() !== "" &&
        data._source.hasOwnProperty("IsConvert") &&
        data._source.IsConvert
      ) {
      } else {
        let receivedPayment = 0;
        if (data._source.hasOwnProperty("ReceivedPaymentTransactions")) {
          for (
            let i = 0;
            i < data._source.ReceivedPaymentTransactions.length;
            i++
          ) {
            let r = data._source.ReceivedPaymentTransactions[i];
            if (r.hasOwnProperty("IsConvert") && r.IsConvert) {
              //ignore
            } else {
              receivedPayment = receivedPayment + Number(r.ReceiveAmount);
            }
          }
        }
        let outStandingAmount =
          Number(data._source.BalanceAmount) - Number(receivedPayment);
        if (outStandingAmount !== 0) {
          sales.push({
            TransactionKey: data._id,
            TransactionNo: data._source.TransactionNo,
            TransactionType: data._source.TransactionType.TransactionType,
            TransactionDate: data._source.TransactionDate,
            TransactionAmount: Number(data._source.BillAmount),
            OutStandingAmount: outStandingAmount,
            ReceiveAmount: 0,
            Selected: false,
          });
        }
      }
    });
    return sales;
  };
}

export function getOutstandingRRN(customerID, storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        constants.API_URL +
          "/crm/customers/rrn?customerID=" +
          customerID +
          "&storeKey=" +
          storeID,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let rrns = [];
      if (response.data && response.data.data) {
        rrns = response.data.data;
      }
      return rrns;
    } catch (error) {
      return [];
    }
  };
  // return database
  //     .collection("RRN")
  //     .where("CustomerID", "==", customerID)
  //     .where("IsDeleted", "==", false)
  //     .get()
  //     .then((querySnapshot) => {
  //       let outstandingRRNs = [];
  //       querySnapshot.forEach((doc) => {
  //         if (doc.data().BalanceAmount > 0) {
  //           outstandingRRNs.push({ key: doc.id, ...doc.data() });
  //         }
  //       });
  //       return outstandingRRNs;
  //     })
  //     .catch((error) => {
  //       return null;
  //     });
}

export function updateDeliveryDetails(deliveryDetails, key) {
  return async (dispatch, getState) => {
    try {
      deliveryDetails.BackEndUpdate = true;
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + "/transaction/sales/" + key,
        deliveryDetails,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let responseSuccess = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        responseSuccess = true;
      }
      return responseSuccess;
    } catch (error) {
      console.error("updateDeliveryDetails failed:", error);
      return false;
    }
  };
  // return database
  //     .collection("Sales")
  //     .doc(key)
  //     .update({ ...deliveryDetails, BackEndUpdate: false });
}

export function updateONDCDeliveryStatus(
  sale,
  status,
  merchantInvoiceNo = "",
  merchantInvoiceAmount = 0
) {
  return async (dispatch, getState) => {
    let transactionStatus = "";
    let deliveryStatus = status;
    if (status === "Packed") {
      transactionStatus = "In-progress";
    }
    if (status === "Out-for-delivery") {
      transactionStatus = "In-progress";
    }
    if (status === "Order-delivered") {
      transactionStatus = "Completed";
    }
    if (status === "Accepted") {
      transactionStatus = "Accepted";
      deliveryStatus = sale.DeliveryStatus;
    }
    if (status === "Order-picked-up") {
      transactionStatus = "Completed";
    }
    let updateData = {
      DeliveryStatus: deliveryStatus,
      TransactionStatus: transactionStatus,
      BackEndUpdate: true,
      Action: status,
      ActionBy: getState().user.user.Name,
      ActionByUID: getState().user.user.UID,
      ActionByEmailID: getState().user.user.EmailID,
      ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
    };

    if (status === "Packed" && merchantInvoiceNo.trim() !== "") {
      updateData.TransactionNo = merchantInvoiceNo.trim();
      updateData.PincodeMerchantInvoiceAmount = merchantInvoiceAmount;
      sale.TransactionNo = merchantInvoiceNo.trim();
      sale.PincodeMerchantInvoiceAmount = merchantInvoiceAmount;
    }

    if (sale.hasOwnProperty("DeliveryPartnerOrderID")) {
      updateData.DeliveryPartnerOrderID = sale.DeliveryPartnerOrderID;
    }
    if (sale.hasOwnProperty("DeliveryPartnerOrderAmount")) {
      updateData.DeliveryPartnerOrderAmount = sale.DeliveryPartnerOrderAmount;
    }
    if (status === "Out-for-delivery") {
      if (sale.hasOwnProperty("DeliveryPersonKey")) {
        updateData.DeliveryPersonKey = sale.DeliveryPersonKey;
      }
      if (sale.hasOwnProperty("DeliveryPersonName")) {
        updateData.DeliveryPersonName = sale.DeliveryPersonName;
      }
      if (sale.hasOwnProperty("DeliveryPersonMobileNo")) {
        updateData.DeliveryPersonMobileNo = sale.DeliveryPersonMobileNo;
      }
      updateData.DeliveryOutForDeliveryActionOn = firebase.firestore.FieldValue.serverTimestamp();
    }
    if (transactionStatus !== "") {
      sale.TransactionStatus = transactionStatus;
    }
    sale.BackEndUpdate = true;
    sale.Action = status;
    sale.ActionBy = getState().user.user.Name;
    sale.ActionByUID = getState().user.user.UID;
    sale.ActionByEmailID = getState().user.user.EmailID;
    sale.DeliveryStatus = deliveryStatus;
    const token = getState().user.uat;
    let response = await axios
      .post(
        constants.API_URL + "/pincode/orderstate/update",
        { ...sale },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if ((res.data.code = "0")) {
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
    return response;
  };
}

export function orderConfirmed(sale, smsNo) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/orderconfirmed",
        { sale, smsNo },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let successResponse = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        successResponse = true;
      }
      return successResponse;
    } catch (error) {
      console.error("orderConfirmed failed:", error);
      return false;
    }
  };

  // return database
  //     .collection("Sales")
  //     .doc(sale.key)
  //     .update({
  //       BackEndUpdate: true,
  //       DeliveryStatus: "Confirmed",
  //       DeliveryConfirmedActionOn: firebase.firestore.FieldValue.serverTimestamp(),
  //       DeliveryConfirmedSMSNo: smsNo,
  //     })
  //     .then(() => {
  //       //send sms
  //       if (smsNo.trim() !== "") {
  //         if (smsNo.trim() !== "") {
  //           let messageText = "";
  //           messageText =
  //             "Dear Customer, Your order " +
  //             sale.TransactionNo +
  //             " has been confirmed and will be delivered shortly.";
  //           let obj = {
  //             RegistrationID: sale.RegistrationID,
  //             StoreID: sale.Store.key,
  //             UserID: sale.ActionByUID,
  //             Module: "sales",
  //             CashRegisterID: sale.CashRegister.key,
  //             MobileNo: smsNo,
  //             TransactionType: "Delivery",
  //             TransactionData: messageText,
  //           };
  //           let addMessage = firebase.functions().httpsCallable("sendSMS");
  //           return addMessage({ text: obj }).then(function(result) {
  //             if (result.data.text) {
  //               return true;
  //             } else {
  //               return false;
  //             }
  //           });
  //         }
  //       }
  //     });
}

export function outForDelivery(
  sale,
  deliveryPersonName,
  deliveryPersonKey,
  deliveryPersonMobileNo
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/outfordelivery",
        { sale, deliveryPersonName, deliveryPersonKey, deliveryPersonMobileNo },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let successResponse = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        successResponse = true;
      }
      return successResponse;
    } catch (error) {
      console.error("outForDelivery failed:", error);
      return false;
    }
  };

  // return (dispatch) => {
  //   return database
  //     .collection("Sales")
  //     .doc(sale.key)
  //     .update({
  //       BackEndUpdate: true,
  //       DeliveryStatus: "Out For Delivery",
  //       DeliveryPersonKey: deliveryPersonKey,
  //       DeliveryPersonName: deliveryPersonName,
  //       DeliveryOutForDeliveryActionOn: firebase.firestore.FieldValue.serverTimestamp(),
  //       DeliveryPersonMobileNo: deliveryPersonMobileNo,
  //     })
  //     .then(() => {
  //       //send sms
  //       if (deliveryPersonMobileNo.trim() !== "") {
  //         let messageText = "";
  //         messageText =
  //           "Dear Customer, Your order " +
  //           sale.TransactionNo +
  //           " is out for delivery.";
  //         let obj = {
  //           RegistrationID: sale.RegistrationID,
  //           StoreID: sale.Store.key,
  //           UserID: sale.ActionByUID,
  //           Module: "sales",
  //           CashRegisterID: sale.CashRegister.key,
  //           MobileNo: deliveryPersonMobileNo,
  //           TransactionType: "Delivery",
  //           TransactionData: messageText,
  //         };
  //         let addMessage = firebase.functions().httpsCallable("sendSMS");
  //         return addMessage({ text: obj }).then(function(result) {
  //           if (result.data.text) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         });
  //       }
  //     });
  // };
}

export function readyForPickup(sale, smsNo) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/readyforpickup",
        { sale, smsNo },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let successResponse = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        successResponse = true;
      }
      return successResponse;
    } catch (error) {
      console.error("readyForPickup failed:", error);
      return false;
    }
  };
  // return (dispatch) => {
  //   return database
  //     .collection("Sales")
  //     .doc(sale.key)
  //     .update({
  //       BackEndUpdate: true,
  //       DeliveryStatus: "Ready For Pickup",
  //       DeliveryReadyForPickupActionOn: firebase.firestore.FieldValue.serverTimestamp(),
  //       DeliveryReadyForPickupSMSNo: smsNo,
  //     })
  //     .then(() => {
  //       //send sms
  //       if (smsNo.trim() !== "") {
  //         if (smsNo.trim() !== "") {
  //           let messageText = "";
  //           messageText =
  //             "Dear Customer, Your order " +
  //             sale.TransactionNo +
  //             " is ready for pickup.";
  //           let obj = {
  //             RegistrationID: sale.RegistrationID,
  //             StoreID: sale.Store.key,
  //             UserID: sale.ActionByUID,
  //             Module: "sales",
  //             CashRegisterID: sale.CashRegister.key,
  //             MobileNo: smsNo,
  //             TransactionType: "Delivery",
  //             TransactionData: messageText,
  //           };
  //           let addMessage = firebase.functions().httpsCallable("sendSMS");
  //           return addMessage({ text: obj }).then(function(result) {
  //             if (result.data.text) {
  //               return true;
  //             } else {
  //               return false;
  //             }
  //           });
  //         }
  //       }
  //     });
  // };
}

export function markDelivered(sale) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + "/markdelivered/" + sale.key,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let successResponse = false;
      if (
        response &&
        response.data &&
        response.data.code &&
        response.data.code === "0"
      ) {
        successResponse = true;
      }
      return successResponse;
    } catch (error) {
      console.error("markDelivered failed:", error);
      return false;
    }
  };
  // return (dispatch) => {
  //   return database
  //     .collection("Sales")
  //     .doc(sale.key)
  //     .update({
  //       BackEndUpdate: true,
  //       DeliveryStatus: "Delivered",
  //       DeliveryDeliveredActionOn: firebase.firestore.FieldValue.serverTimestamp(),
  //     })
  //     .then(() => {});
  // };
}

export function getDeliveryStatusSummary(registrationID, storeID) {
  let searchParameters = {
    size: 0,
    query: {
      bool: {
        must: [
          {
            term: {
              RegistrationID: {
                value: registrationID,
              },
            },
          },
        ],
        must_not: [{ exists: { field: "CancellationReason" } }],
      },
    },
    aggs: {
      group_by_DeliveryStatus: {
        terms: {
          field: "DeliveryStatus.keyword",
        },
      },
      group_by_TransactionStatus: {
        terms: {
          field: "TransactionStatus.keyword",
        },
      },
    },
  };
  if (storeID !== "") {
    searchParameters.query.bool.must.push({
      match: {
        "Store.key": storeID,
      },
    });
  }
  return async (dispatch, getState) => {
    const token = getState().user.uat;
    let result = await axios
      .post(
        constants.API_URL + "/transaction/getsales",
        {
          text: searchParameters,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});
    const summary = [];
    let sanitizedMessage = result.text;
    sanitizedMessage.aggregations.group_by_DeliveryStatus.buckets.map(
      (data, index) => {
        summary.push({ status: data.key, count: data.doc_count });
      }
    );
    sanitizedMessage.aggregations.group_by_TransactionStatus.buckets.map(
      (data, index) => {
        summary.push({ status: data.key, count: data.doc_count });
      }
    );
    return summary;
  };
}

export function getDeliveryDetailReportInfinityApp(
  registrationID,
  from,
  size,
  transactionStatus,
  searchTransactionNo,
  searchTransactionFromDate,
  searchTransactionToDate,
  searchCustomerDetail,
  searchStore,
  searchEmployeeName,
  externalTransactionNo = ""
) {
  let searchParameters = {
    from: from,
    size: size,
    track_total_hits: true,
    query: {
      bool: {
        must: [
          {
            term: {
              RegistrationID: registrationID,
            },
          },
          {
            exists: {
              field: "ExternalTransactionNo",
            },
          },
        ],
        must_not: [
          {
            term: {
              ExternalTransactionNo: "",
            },
          },
        ],
        filter: {
          bool: {
            must: [],
            should: [],
          },
        },
      },
    },
    sort: [],
  };
  if (transactionStatus !== "") {
    searchParameters.query.bool.must.push({
      match_phrase: { TransactionStatus: transactionStatus },
    });
  }
  if (searchCustomerDetail.trim() !== "") {
    searchParameters.query.bool.filter.bool.should.push({
      match_phrase: {
        "Customer.FirstName":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      match_phrase: {
        "Customer.LastName":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.EmailID":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.PhoneNo":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.CustomerCode":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });

    searchParameters.query.bool.filter.bool.minimum_should_match = 1;
  }

  if (searchTransactionNo.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match_phrase: { TransactionNo: searchTransactionNo.trim().toLowerCase() },
    });
  }
  if (externalTransactionNo.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      wildcard: {
        ExternalTransactionNoText:
          "*" + externalTransactionNo.trim().toLowerCase() + "*",
      },
    });
  }
  if (searchStore.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match: { "Store.key": searchStore },
    });
  }
  if (searchEmployeeName.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match_phrase: {
        DeliveryOutForDeliveryEmployee: searchEmployeeName.trim(),
      },
    });
  }
  if (
    searchTransactionToDate.trim() !== "" &&
    searchTransactionFromDate.trim() !== ""
  ) {
    searchParameters.query.bool.must.push({
      range: {
        DeliveryDate: {
          lte: searchTransactionToDate,
          gte: searchTransactionFromDate,
          format: "yyyy-MM-dd",
        },
      },
    });
  }

  if (
    transactionStatus.toLowerCase() === "cancelled" ||
    transactionStatus.toLowerCase() === "all" ||
    transactionStatus.toLowerCase() === "delivered"
  ) {
    searchParameters.sort.push({
      TransactionDate: {
        order: "desc",
      },
    });
  } else {
    searchParameters.sort.push({
      TransactionDate: {
        order: "asc",
      },
    });
  }
  return async (dispatch, getState) => {
    const token = getState().user.uat;
    let result = await axios
      .post(
        constants.API_URL + "/transaction/getsales",
        {
          text: searchParameters,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});
    const invoices = [];
    let sanitizedMessage = result.text;
    sanitizedMessage.hits.hits.map((data, index) => {
      invoices.push({ key: data._id, ...data._source });
    });
    return {
      totalItemsCount: sanitizedMessage.hits.total.value,
      searchResult: invoices,
    };
  };
}

export function getDeliveryDetailReport(
  registrationID,
  from,
  size,
  option,
  searchTransactionNo,
  searchTransactionFromDate,
  searchTransactionToDate,
  searchCustomerDetail,
  searchStore,
  searchEmployeeName,
  externalTransactionNo = "",
  onlineOrder = true
) {
  let searchParameters = {
    from: from,
    size: size,
    track_total_hits: true,
    query: {
      bool: {
        must: [
          {
            term: {
              RegistrationID: registrationID,
            },
          },
        ],
        must_not: [],
        filter: {
          bool: {
            must: [],
            should: [],
          },
        },
      },
    },
    sort: [],
  };

  if (onlineOrder) {
    searchParameters.query.bool.must.push({
      exists: {
        field: "ExternalTransactionNo",
      },
    });
  }
  // desc
  if (option.toLowerCase() === "created") {
    searchParameters.query.bool.must.push({
      match_phrase: { TransactionStatus: "Created" },
    });
  } else if (option.toLowerCase() === "accepted") {
    searchParameters.query.bool.must.push({
      match_phrase: { TransactionStatus: "Accepted" },
    });
  } else if (option === "pending") {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": "Pending" },
    });
  } else if (option.toLowerCase() === "confirmed") {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": "Confirmed" },
    });
  } else if (option.toLowerCase() === "outfordelivery") {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": "Out For Delivery" },
    });
  } else if (option.toLowerCase() === "readyforpickup") {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": "Ready For Pickup" },
    });
  } else if (option.toLowerCase() === "delivered") {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": "Delivered" },
    });
  } else if (option.toLowerCase() === "all") {
    searchParameters.query.bool.must.push({
      exists: { field: "DeliveryStatus" },
    });
  } else {
    searchParameters.query.bool.must.push({
      term: { "DeliveryStatus.keyword": option },
    });
  }
  if (option.toLowerCase() !== "cancelled" && option.toLowerCase() !== "all") {
    searchParameters.query.bool.must_not.push({
      exists: {
        field: "CancellationReason",
      },
    });
  }

  if (searchCustomerDetail.trim() !== "") {
    searchParameters.query.bool.filter.bool.should.push({
      match_phrase: {
        "Customer.FirstName":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      match_phrase: {
        "Customer.LastName":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.EmailID":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.PhoneNo":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });
    searchParameters.query.bool.filter.bool.should.push({
      regexp: {
        "Customer.CustomerCode":
          "@" + searchCustomerDetail.trim().toLowerCase() + ".*",
      },
    });

    searchParameters.query.bool.filter.bool.minimum_should_match = 1;
  }

  if (searchTransactionNo.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match_phrase: { TransactionNo: searchTransactionNo.trim().toLowerCase() },
    });
  }
  if (externalTransactionNo.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      wildcard: {
        ExternalTransactionNoText:
          "*" + externalTransactionNo.trim().toLowerCase() + "*",
      },
    });
  }
  if (searchStore.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match: { "Store.key": searchStore },
    });
  }
  if (searchEmployeeName.trim() !== "") {
    searchParameters.query.bool.filter.bool.must.push({
      match_phrase: {
        DeliveryOutForDeliveryEmployee: searchEmployeeName.trim(),
      },
    });
  }
  if (
    searchTransactionToDate.trim() !== "" &&
    searchTransactionFromDate.trim() !== ""
  ) {
    searchParameters.query.bool.must.push({
      range: {
        DeliveryDate: {
          lte: searchTransactionToDate,
          gte: searchTransactionFromDate,
          format: "yyyy-MM-dd",
        },
      },
    });
  }

  if (
    option.toLowerCase() === "cancelled" ||
    option.toLowerCase() === "all" ||
    option.toLowerCase() === "order-delivered"
  ) {
    searchParameters.sort.push({
      TransactionDate: {
        order: "desc",
      },
    });
  } else {
    searchParameters.sort.push({
      TransactionDate: {
        order: "asc",
      },
    });
  }

  return async (dispatch, getState) => {
    const token = getState().user.uat;
    let result = await axios
      .post(
        constants.API_URL + "/transaction/getsales",
        {
          text: searchParameters,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});
    const invoices = [];
    let sanitizedMessage = result.text;
    sanitizedMessage.hits.hits.map((data, index) => {
      invoices.push({ key: data._id, ...data._source });
    });
    return {
      totalItemsCount: sanitizedMessage.hits.total.value,
      searchResult: invoices,
    };
  };
}

// export function updateOrderStatus(sale, status) {
//   return (dispatch, getState) => {
//     return database
//       .collection("UrbanPiperOrders")
//       .doc(sale.key)
//       .update({
//         ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//         ActionBy: getState().user.user.Name,
//         ActionByUID: getState().user.user.UID,
//         ActionByEmailID: getState().user.user.EmailID,
//         Action: constants.AUDIT_TRAIL_EDIT,
//         BackEndUpdate: false,
//         Status: status,
//         Message: "",
//       })
//       .then(() => {});
//   };
// }
